import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login/Login';
import Main from '@/views/Main';

import Demo from '@/views/Demo';
import infoSetIndex from '@/views/infoSetIndex';
import developmentSystem from './modules/developmentSystem';
import systemMaintain from './modules/systemMaintain';
import customService from './modules/customService';
import dataAnalysis from './modules/dataAnalysis';
import miscRoutes from './modules/miscRoutes';
import systemoperation from './modules/systemoperation';
import iPayment from './modules/iPayment';
import newiPayment from './modules/newsPayment';
import cockpitHome from '@/views/iPayment/cockpitHome'
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/infoSetIndex',
      name: 'infoSetIndex',
      component: infoSetIndex
    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo
    },
    {
      path: '/cockpitHome',
      name: 'cockpitHome',
      component: cockpitHome
    },
    /**
     * 解小雨定制演示页面
     */
    {
        path: '/demonstration/schoolDetail',
        name: 'schoolDetail',
        component: () => import('@/views/schoolManage/schoolDetail')
    },
    {
        path: '/demonstration/schoolAppList',
        name: 'schoolAppList',
        component: () => import('@/views/schoolManage/schoolAppManage/schoolAppList')
    },
    /**
     * 解小雨定制演示页面
     */
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: [
        ...developmentSystem,
        ...systemMaintain,
        ...customService,
        ...dataAnalysis,
        ...miscRoutes,
        ...systemoperation,
        ...iPayment,
        ...newiPayment
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js